import * as DTOS from "../FeralScan.dtos";
import { FilterState } from "../reducers/filter.reducer";

export interface IDashboardActions {
    type: string;
}

export interface IFlagPlotSuccess extends IDashboardActions {
    plots: DTOS.Plot[];
}

export interface IUpdatePlotRequest extends IDashboardActions {
    plot: DTOS.Plot;
}

export interface IUpdatePlotSuccess extends IDashboardActions {
    plot: DTOS.Plot;
}

export interface IUploadPlotPhotosRequest extends IDashboardActions {
    files: File[];
    plotId: number;
}

export interface IUploadPlotPhotosSuccess extends IDashboardActions {
}

export interface IUploadPlotPhotosFailure extends IDashboardActions {
}

export interface IDeleteFileRequest extends IDashboardActions {
    fileId: number;
}

export interface IDeleteFileSuccess extends IDashboardActions {
}

export interface IDeleteFileFailure extends IDashboardActions {
}

export interface ICreatePlotRequest extends IDashboardActions {
    plot: DTOS.Plot;
}

export interface ICreatePlotSuccess extends IDashboardActions {
    plot: DTOS.Plot;
}

export type DashboardAction = {
    type: string;

    //getQuestionReferenceDataRequest getReferenceDataSuccess
    classifications?: DTOS.QuestionOption[];

    //getReferenceDataSuccess
    currentUser?: DTOS.User;
    dateRange?: DTOS.OptionDateExtended[];

    //errorRequest
    errorMessage?: string;

    //reportRequest saveFilterRequest searchRequest
    filters?: FilterState;

    //getReferenceDataSuccess
    groups?: DTOS.QuestionOption[];

    //flagPlotRequest savePlotRequest savePlotSuccess showPlotRequest
    plot?: DTOS.Plot;

    //loadFilterRequest saveFilterRequest saveFilterSuccess
    preference?: DTOS.UserPreference;

    //getQuestionReferenceDataSuccess
    questions?: DTOS.QuestionOption[];

    //getReferenceDataSuccess
    regions?: DTOS.QuestionOption[],
    savedFilters?: DTOS.UserPreference[],
    states?: DTOS.QuestionOption[],
    surveys?: DTOS.Survey[]

    //changeTabRequest
    tab?: string;

    //getReferenceDataSuccess
    types?: DTOS.QuestionOption[];

    //getReferenceDataSuccess searchSuccess
    userPreference?: DTOS.UserPreference;
}

export interface IDashboardActions {
    type: string;
}

export interface IGetReferenceDataRequestAction extends IDashboardActions { }

export interface IGetReferenceDataSuccessAction extends IDashboardActions {
    response: DTOS.GetReferenceDataResponse;
    /*classifications: DTOS.Classification[];
    dateRange: DTOS.OptionDateExtended[];
    plotStatuses: DTOS.PlotStatus[];
    surveys: DTOS.Survey[],
    types: DTOS.QuestionOption[];
    userPreference: DTOS.UserPreference;
    userPreference: DTOS.UserPreference;
    websiteSettings: DTOS.WebsiteSettings;*/
}



export const
    ERROR_REQUEST = "ERROR_REQUEST",

    REPORT_REQUEST = "REPORT_REQUEST",
    REPORT_SUCCESS = "REPORT_SUCCESS",

    BACK_TAB_REQUEST = "BACK_TAB_REQUEST",

    FLAG_PLOT_REQUEST = "FLAG_PLOT_REQUEST",
    FLAG_PLOT_SUCCESS = "FLAG_PLOT_SUCCESS",

    CREATE_PLOT_REQUEST = "CREATE_PLOT_REQUEST",
    CREATE_PLOT_SUCCESS = "CREATE_PLOT_SUCCESS",

    UPDATE_PLOT_REQUEST = "UPDATE_PLOT_REQUEST",
    UPDATE_PLOT_SUCCESS = "UPDATE_PLOT_SUCCESS",

    UPLOAD_PLOT_PHOTOS_REQUEST = "UPLOAD_PLOT_PHOTOS_REQUEST",
    UPLOAD_PLOT_PHOTOS_SUCCESS = "UPLOAD_PLOT_PHOTOS_SUCCESS",
    UPLOAD_PLOT_PHOTOS_FAILURE = "UPLOAD_PLOT_PHOTOS_FAILURE",

    FILE_DELETE_REQUEST = "FILE_DELETE_REQUEST",
    FILE_DELETE_SUCCESS = "FILE_DELETE_SUCCESS",
    FILE_DELETE_FAILURE = "FILE_DELETE_SUCCESS",

    SAVE_REQUEST = "SAVE_REQUEST",
    SAVE_SUCCESS = "SAVE_SUCCESS",
    SAVE_LOAD = "SAVE_LOAD",

    REFERENCE_DATA_REQUEST = "REFERENCE_DATA_REQUEST",
    REFERENCE_DATA_SUCCESS = "REFERENCE_DATA_SUCCESS",

    QUESTION_REFERENCE_DATA_REQUEST = "QUESTION_REFERENCE_DATA_REQUEST",
    QUESTION_REFERENCE_DATA_SUCCESS = "QUESTION_REFERENCE_DATA_SUCCESS";

export function backTabRequest(): DashboardAction {
    return {
        type: BACK_TAB_REQUEST
    };
}

export function errorRequest(errorMessage: string): DashboardAction {
    return {
        type: ERROR_REQUEST,
        errorMessage
    }
}

export function flagPlotRequest(plot: DTOS.Plot): DashboardAction {
    return {
        type: FLAG_PLOT_REQUEST,
        plot
    };
}

export function flagPlotSuccess(response: DTOS.FlagPlotResponse): IFlagPlotSuccess {
    return {
        type: FLAG_PLOT_SUCCESS,
        plots: response.plots
    };
}

export function updatePlotRequest(plot: DTOS.Plot): IUpdatePlotRequest {
    return {
        type: UPDATE_PLOT_REQUEST,
        plot
    };
}

export function updatePlotSuccess(response: DTOS.SavePlotResponse): IUpdatePlotSuccess {
    return {
        type: UPDATE_PLOT_SUCCESS,
        plot: response.plot
    };
}

export function uploadPlotPhotosRequest(files: File[], plotId: number): IUploadPlotPhotosRequest {
    return {
        type: UPLOAD_PLOT_PHOTOS_REQUEST,
        files,
        plotId
    };
}

export function uploadPlotPhotosSuccess(response: DTOS.UploadPlotPhotosResponse): IUploadPlotPhotosSuccess {
    return {
        type: UPLOAD_PLOT_PHOTOS_SUCCESS
    };
}

export function uploadPlotPhotosFailure(): IUploadPlotPhotosFailure {
    return {
        type: UPLOAD_PLOT_PHOTOS_FAILURE
    };
}

export function deleteFileRequest(fileId: number): IDeleteFileRequest {
    return {
        type: FILE_DELETE_REQUEST,
        fileId,
    };
}

export function deleteFileSuccess(response: DTOS.DeleteFileResponse): IDeleteFileSuccess {
    return {
        type: FILE_DELETE_SUCCESS
    };
}

export function deleteFileFailure(): IDeleteFileFailure {
    return {
        type: FILE_DELETE_FAILURE
    };
}

export function createPlotRequest(plot: DTOS.Plot): ICreatePlotRequest {
    return {
        type: CREATE_PLOT_REQUEST,
        plot
    };
}

export function createPlotSuccessAction(response: DTOS.SavePlotResponse): ICreatePlotSuccess {
    return {
        type: CREATE_PLOT_SUCCESS,
        plot: response.plot
    };
}

export function reportRequest(filters: FilterState): DashboardAction {
    return {
        type: REPORT_REQUEST,
        filters: filters
    };
}

export function reportSuccess(response: DTOS.ReportResponse): DashboardAction {
    return {
        type: REPORT_SUCCESS
    };
}

export function saveFilterRequest(preference: DTOS.UserPreference, filters: FilterState): DashboardAction {
    return {
        type: SAVE_REQUEST,
        preference: preference,
        filters: filters
    };
}

//NOTE: this is not called anywhere
//TODO: Determine whether to implement somewhere or delete
export function saveFilterSuccess(response: { userPreference: DTOS.UserPreference }): DashboardAction {
    return {
        type: SAVE_SUCCESS,
        preference: response.userPreference,
    };
}


export function loadFilterRequest(preference: DTOS.UserPreference): DashboardAction {
    return {
        type: SAVE_LOAD,
        preference: preference,
    };
}

export function getReferenceDataRequest(): IGetReferenceDataRequestAction {
    return {
        type: REFERENCE_DATA_REQUEST
    };
}

export function getReferenceDataSuccess(response: DTOS.GetReferenceDataResponse): IGetReferenceDataSuccessAction {

    return {
        type: REFERENCE_DATA_SUCCESS,
        response: response
        /*classifications: response.classifications,
        dateRange: response.dateRange,
        plotStatuses: response.plotStatuses,
        surveys: response.surveys,
        types: response.types,
        userPreference: response.userPreference,
        websiteSettings: response.websiteSettings,*/
    };
}

export function getQuestionReferenceDataRequest(classifications: DTOS.QuestionOption[]): DashboardAction {
    return {
        type: QUESTION_REFERENCE_DATA_REQUEST,
        classifications
    };
}

export function getQuestionReferenceDataSuccess(response: DTOS.GetQuestionReferenceDataResponse): DashboardAction {
    return {
        type: QUESTION_REFERENCE_DATA_SUCCESS,
        questions: response.result,
    };
}
